export default {_name:'button.simple',module:'Field',view:'Element/Button',options:{variant:'contained',color:'secondary',xs:4}}